import { jsonProperty, Serializable } from 'ts-serializable';

import { SurveyResultItemModel } from '~modules/surveys/models/SurveyResultItemModel';

// Пройденный опрос, модель для показа результатов (readonly)
export class SurveyResultsModel extends Serializable {
  @jsonProperty(String, null) headerText: string | null = null;
  @jsonProperty(String, null) carDescr: string | null = null;
  @jsonProperty(Number, null) formId: number | null = null;
  @jsonProperty(Number, null) workOrderId: number | null = null;
  @jsonProperty(Number, null) carId: number | null = null;
  @jsonProperty([SurveyResultItemModel]) results: SurveyResultItemModel[] = [];
  @jsonProperty(String, null) dateDealerNotesAdd: string | null = null;
  @jsonProperty(String, null) dealerNotesAddUserName: string | null = null;
}
